var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11106",
    "data-name": "Group 11106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.758,
    height: 45.216,
    viewBox: "0 0 60.758 45.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 60.758,
    height: 45.216,
    fill: "#77ffa5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 8.354,
    height: 32.298,
    fill: "#77ffa5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M105.837,46.593a42.535,42.535,0,0,1,1.651,11.171c0,9.422-4.274,14.327-12.336,14.327-6.314,0-9.276-2.865-9.276-8.839V46.593h8.159V62.28c0,2.331.243,3.545,2.04,3.545,2.769,0,3.448-3.837,3.448-7.819a51.36,51.36,0,0,0-1.651-11.413Z",
    transform: "translate(-72.18 -39.162)",
    fill: "#77ffa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M259.159,46.593V61.6c0,2.04-1.166,3.254-2.768,3.254-2.331,0-2.477-1.651-2.477-4.274V46.593h-8.159V61.7c0,4.031,1.943,6.945,6.071,7.722-3.06,2.234-4.808,4.954-4.808,8.257,0,4.128,2.914,6.7,8.451,6.7,7.139,0,10.976-3.837,11.7-11.608.146-1.457.146-5.44.146-6.8V46.593Zm.945,29.449c-.7,2.614-2.807,2.835-5.039,2.65a5.045,5.045,0,0,0,.011,1.639.736.736,0,0,1-.381.006A10.024,10.024,0,0,1,258.121,72c-2.61,1.083-3.826,5.365-3.586,6.451-.8-1.133-1.574-2-1.433-3.555.28-3.094,4.665-5.473,9.025-4.151-2.059,1.226-1.45,3.153-2.024,5.294",
    transform: "translate(-206.56 -39.162)",
    fill: "#77ffa5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f0f15aff9c8c9af6c76919583a1a3aa.svg";
export { ForwardRef as ReactComponent };